/**
 * @file Content.tsx
 * @module _admin/layout/components/content/Content
 * @description Renders the Content layout component that structures the main page content area.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { useEffect } from "react";
import { useLocation } from "react-router";
import clsx from "clsx";
import { useLayout } from "../../core";
import { DrawerComponent } from "../../../assets/ts/components";
import { WithChildren } from "../../../helpers";
import { PageTitleWrapper } from "../toolbar/page-title";

import { Notification } from "../../../../app/notification/notification";

const Content = ({ children }: WithChildren) => {
  const { config, classes } = useLayout();
  const location = useLocation();
  useEffect(() => {
    DrawerComponent.hideAll();
  }, [location]);

  const appContentContainer = config.app?.content?.container;
  return (
    <>
      <div
        id="kt_app_content"
        className={clsx(
          "app-content flex-column-fluid p-0",
          classes.content.join(" "),
          config?.app?.content?.class
        )}
      >
        {appContentContainer ? (
          <div
            id="kt_app_content_container"
            className={clsx(
              "app-container",
              classes.contentContainer.join(" "),
              {
                "container-xxl": appContentContainer === "fixed",
                "container-fluid": appContentContainer === "fluid",
              }
            )}
          >
            <PageTitleWrapper />
            {children}
          </div>
        ) : (
          <>
            <PageTitleWrapper />
            {children}
          </>
        )}
      </div>
    </>
  );
};

export { Content };
